import type { IWhereUsedSectionTab } from '~/components/pages/directions/where-used-section/where-used-section.types'

const WHERE_USED_ARENDA_AUDIOGUIDE: IWhereUsedSectionTab[] = [
    {
        title: 'Музеи и выставки',
        image: '/assets/images/usage/audioguide/jpg-png/in-museum-3.jpg',
        image_webp: '/assets/images/usage/audioguide/webp/in-museum-3.webp',
        text: `
                <p>Автоматизированные экскурсии, как групповые, так и&nbsp;индивидуальные, без необходимости в&nbsp;сопровождении экскурсоводом. Можно наслаждаться аудиоэкскурсиями как в&nbsp;наушниках, так и&nbsp;через динамики.</p>
                <p>Благодаря профессиональной студийной записи голоса диктора, его речь будет хорошо слышна в&nbsp;наушниках даже в&nbsp;условиях шума. Организуем запись вашего контента на&nbsp;профессиональной студии с&nbsp;опытным диктором.</p>
            `,
    },
    {
        title: 'На производстве',
        image: '/assets/images/usage/audioguide/jpg-png/moskvich.jpg',
        image_webp: '/assets/images/usage/audioguide/webp/moskvich.webp',
        text: `
                <p>С&nbsp;помощью аудиогидов можно проводить экскурсии и&nbsp;лекции даже в&nbsp;самых шумных местах, таких как заводы или фабрики. Четкая дикторская запись и&nbsp;использование стереонаушников обеспечивают ясность и&nbsp;комфорт для слушателей. Наушники могут быть как многоразовыми, для повторного использования, так и&nbsp;одноразовыми, которые остаются у&nbsp;посетителя.</p>
                <p>Наши аудиогиды часто используют не&nbsp;только для потенциальных клиентов производственных компаний, но&nbsp;и&nbsp;для новых сотрудников, которым необходимо пройти обучение в&nbsp;условиях повышенного шума (для примера, Автозавод &laquo;Москвич)&raquo;.</p>
            `,
    },
    {
        title: 'Речные круизы',
        image: '/assets/images/usage/audioguide/jpg-png/boat-group-tour-2-scale.jpg',
        image_webp:
            '/assets/images/usage/audioguide/webp/boat-group-tour-2-scale.webp',
        text: `
                <p>Благодаря экскурсионным аудиогидам SPBAUDIO, больше не&nbsp;возникнет сложностей из-за звуков ветра на&nbsp;воде или шума моторов судна.</p>
                <p>Полная автоматизация экскурсионного процесса значительно снижает затраты компании, особенно при больших объемах пассажиропотока.</p>
                <p>Теперь туристы имеют возможность самостоятельно настраивать язык и&nbsp;уровень громкости, что делает их&nbsp;поездку более комфортной.</p>
            `,
    },
    {
        title: 'Автобусные туры',
        image: '/assets/images/usage/audioguide/jpg-png/bus-tour-2.png',
        image_webp: '/assets/images/usage/audioguide/webp/bus-tour-2.webp',
        text: `
                <p>Теперь шум дороги и&nbsp;соседей, а&nbsp;также звук работающего двигателя не&nbsp;помешают вашим клиентам насладиться экскурсиями благодаря аудиогидам SPBAUDIO. Эти устройства обеспечивают полную автоматизацию экскурсий, что значительно облегчает работу организатора и&nbsp;позволяет эффективно обслуживать поток пассажиров.</p>
                <p>Каждый турист имеет возможность самостоятельно выбрать язык и&nbsp;настроить громкость звука, что делает процесс еще более комфортным и&nbsp;индивидуальным.</p>
            `,
    },
]

export default WHERE_USED_ARENDA_AUDIOGUIDE
